<section [style.height.px]="height" [class.visible]="isVisible" #section>
  <ng-content/>
</section>
